<div class="container-fluid p-4 pt-0">
  <kendo-pdf-export
    #pdf
    paperSize="A4"
    [landscape]="true"
    margin="1cm"
    [scale]="0.6"
    forcePageBreak=".page-break, .force-page-break"
    [imageResolution]="300"
    [keepTogether]="'.keep-together'"
  >
    <!-- Export Button Row -->
    @if (showExportButton()) {
      <div class="row mb-3">
        <div class="col-12">
          <div class="d-flex justify-content-end">
            <button
              kendoButton
              (click)="exportToPdf()"
              [size]="exportButtonSize()"
              class="cyflare-btn-secondary cyflare-btn-icon"
              title="Export to PDF"
              [svgIcon]="exportIcon"
            ></button>
          </div>
        </div>
      </div>
    }

    <!-- Common Filter Header Area -->
    @if (showFilterHeader()) {
      <div class="row mb-2">
        <div class="col-12">
          <div class="analytics-header p-3">
            <div class="d-flex justify-content-between align-items-center">
              <div class="filter-group">
                <ng-content select="[filter-content]"></ng-content>
              </div>
              @if (showFilterExportButton()) {
                <button
                  kendoButton
                  (click)="exportToPdf()"
                  [size]="exportButtonSize()"
                  class="cyflare-btn-secondary cyflare-btn-icon"
                  title="Export to PDF"
                  [svgIcon]="exportIcon"
                ></button>
              }
            </div>
          </div>
        </div>
      </div>
    }

    <!-- Common Metric Cards Grid Layout -->
    @if (showMetricCardsGrid()) {
      <div class="row g-3 mb-2">
        <ng-content select="[metric-cards-content]"></ng-content>
      </div>
    }

    <!-- Common Chart Grid Layout -->
    @if (showChartGrid()) {
      <div class="row g-3 mb-2">
        <ng-content select="[chart-grid-content]"></ng-content>
      </div>
    }

    <!-- Content Area - To be filled by child components -->
    <ng-content></ng-content>
  </kendo-pdf-export>
</div>
